import { AboServicesService } from '@/services/abo-services.service';

export default {
  getStatuses({ commit }) {
    return AboServicesService.getStatuses().then(response => {
      commit('setStatuses', response.data.data);

      return response;
    });
  },

  getAboServices({ commit }, { params } = {}) {
    return AboServicesService.getList(params).then(response => {
      commit('setAboServices', response.data.data);

      return response;
    });
  },
};
